module.exports = __webpack_public_path__ + "img/geh.f2d3a8d8.png";